import React from "react"
import { NavLink } from "react-router-dom"
import Header4 from "../Common/Header4"
import Footer from "../Common/Footer"
import Banner from "../Elements/Banner"
import Projects6 from "../Elements/Projects6"
import ReactPlayer from "react-player"

var bnrimg = require("./../../images/four/big.png")

class Four extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title=" Four season hotel"
            pagename=" Four season hotel"
            description="Located on the Red Sea in Jeddah, this Midad Real Estate project, operated by Four Seasons, 
features four towers with a 247-room hotel, serviced apartments, and private residences. 
Amenities include a spa, pools, and event spaces. BIM services were provided by INNEN 
Interiors, with Havelock One as the ID contractor and Richmond as the ID designer."
            bgimage={bnrimg}
          />

          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 inner-page-padding stick_in_parent">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-7  sticky_column">
                  <div className="project-detail-containt">
                    <div className="bg-white text-black">
                      <h3>
                        A multitask profession which creates any land in
                        beautiful creation{" "}
                      </h3>
                      <p>
                        {" "}
                        This Midad Real Estate project, operated by Four
                        Seasons, features four towers with a 247-room hotel,
                        serviced apartments, and private residences. Amenities
                        include a spa, pools, and event spaces. BIM services
                        were provided by INNEN Interiors, with Havelock One as
                        the ID contractor and Richmond as the ID designer.
                      </p>
                      <div className="product-block">
                        <ul>
                          <li>
                            <h4 className="m-b10">Date</h4>
                            <p>Completed</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Client</h4>
                            <p>Midad Real Estate</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Operator</h4>
                            <p>Four Season</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Project type</h4>
                            <p>Hotel</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Location</h4>
                            <p>on the Red Sea in Jeddah</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Year</h4>
                            <p>2022</p>
                          </li>
                          {/* <li>
                            <h4 className="m-b10">Scope of work</h4>
                            <p>
                              BIM services & Engineering coordination for guest
                              rooms, public areas, specialty retaurant, spa &
                              fitness
                            </p>
                          </li> */}
                        </ul>
                      </div>
                      <div className="m-b0">
                        <div className="sx-divider divider-1px  bg-black">
                          <i className="icon-dot c-square" />
                        </div>
                      </div>
                      {/* <ul className="social-icons social-square social-darkest m-b0">
                                            <li><a href="https://www.facebook.com" target="_blank" className="fa fa-facebook" /></li>
                                                <li><a href="https://twitter.com" target="_blank" className="fa fa-twitter" /></li>
                                                <li><a href="https://in.linkedin.com" target="_blank" className="fa fa-linkedin" /></li>
                                                <li><a href="https://rss.com" target="_blank" className="fa fa-rss" /></li>
                                                <li><a href="https://www.youtube.com" target="_blank" className="fa fa-youtube" /></li>
                                                <li><a href="https://www.instagram.com/innen_interiors/" target="_blank" className="fa fa-instagram" /></li>
                                            </ul> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 ">
                  <div className="project-detail-outer">
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/four/1.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/four/2.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/four/3.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/four/4.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/four/5.png")}
                          alt=""
                        />
                      </div>
                    </div>
                    {/* <div className="sx-box">
                                            <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                                                <img src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg" alt="" />
                                                <NavLink to={"#"} className="play-now" data-toggle="modal" data-target="#myModal5">
                                                    <i className="icon fa fa-play" />
                                                    <span className="ripple" />
                                                </NavLink>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
              <div className="project-detail-containt-2 m-t50">
                <h3>
                  Creating a sustainable future through building preservation,
                  green architecture, and smart design
                </h3>
                <p className="m-b0">
                  {" "}
                  Designers think everything done by someone else is awful, and
                  that they could do it better themselves, which explains why I
                  designed my own living room carpet, I suppose. the architect
                  represents neither a Dionysian nor an Apollinian condition:
                  here it is the mighty act of will, the will which moves
                  mountains, the intoxication of the strong will, which demands
                  artistic expression. The most powerful men have always
                  inspired the architects; the architect has always been
                  influenced by power.
                </p>
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END  */}
          {/* <Projects6 /> */}
        </div>

        <div className="modal fade" id="myModal5" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <ReactPlayer url="https://www.youtube.com/watch?v=Oy2QIiSQT2U" />
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default Four
